<template>
    <div v-show="newPost" class="blog-page__editor-placeholder">
        <v-text-field :disabled="editMode" v-model="newPostId" label="Raksta url identifikators (raksta-nosaukums)" autofocus></v-text-field>
        <v-text-field v-model="newPostTitle" label="Raksta nosaukums"></v-text-field>

        <v-container grid-list-xl>
            <v-layout>
                <v-flex xs12 sm6>
                    <v-select v-model="newPostTag" :items="postTags" item-text="tag" label="Tag" return-object ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-text-field
                            label="Thumbnail (jpg, jpeg, png)"
                            :value="thumbnailUploadFileString"
                            hint="Rediģējot var nemainīt"
                            readonly
                            prepend-inner-icon="attach_file"
                            @click="triggerThumbnailFileSelect">
                    </v-text-field>
                    <input ref="uploadThumbnailRef"
                           accept=".png, .jpg, .jpeg"
                           style="display: none;"
                           @change="thumbnailFileListChange()"
                           type="file">
                </v-flex>
            </v-layout>

            <v-flex>
                <v-textarea
                        counter="120"
                        rows="3"
                        label="Īss apraksts (twīta garumā)"
                        v-model="newPostDescription"
                ></v-textarea>
            </v-flex>

            <v-switch color="#38b100" v-model="published" label="Publicēt"></v-switch>
        </v-container>

        <div id="editor"></div>

        <div class="blog-page__post-btn">
            <v-btn dark color="#BA3000" @click="toggleWritePost">Atcelt</v-btn>
            <v-btn v-if="!submittingPost" dark color="#38B100" @click="submitPost">Publicēt</v-btn>
            <v-progress-circular v-show="submittingPost" indeterminate color="green"></v-progress-circular>
        </div>
    </div>
</template>

<script>
    import firebaseCfg from "../firebaseConfig";
    import firebase from 'firebase/app'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    export default {
        name: "PostEditor",
        props: {
            editPostData: Object,
            docId: String,
            author: String,
            editor: String
        },
        data() {
            return {
                editMode: false,
                postTags: [
                    { tag: 'Svētki', color: '#4caf50' },
                    { tag: 'Ziņas', color: '#1867C0' },
                    { tag: 'Blogs', color: '#FF5D09' }
                ],
                published: false,
                newPost: false,
                newPostId: '',
                newPostTag: '',
                newPostTitle: '',
                presetCreateDate: null,
                thumbnailUploadFileString: '',
                thumbnailFileList: null,
                newPostDescription: '',
                newPostBtnTxt: '',
                submittingPost: false,
                editorInstance: null
            }
        },
        methods: {
            toggleWritePost: function(){
                const that = this;

                if(that.editPostData){
                    that.editMode = true;
                }

                if(that.newPost === false){
                    that.newPost = true;
                    that.newPostBtnTxt = 'Jauns ieraksts';

                    that.$emit('toggle-post', that.newPost);

                    if(that.editorInstance){
                        that.editorInstance.destroy();
                    }

                    class MyUploadAdapter {
                        constructor( loader ) {
                            // The file loader instance to use during the upload.
                            this.loader = loader;
                        }

                        // Starts the upload process.
                        upload() {
                            return this.loader.file
                                .then( file => new Promise( ( resolve, reject ) => {
                                    debugger;
                                    const imageRef = firebase.storage().ref().child('posts/'+that.newPostId+'/'+file.name);
                                    const uploadTask = imageRef.put(file);

                                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, function(/*snapshot*/) {
//                              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    }, function(error) {
                                        that.submittingPost = false;

                                        switch (error.code) {
                                            case 'storage/unauthorized':
                                                console.log("unauthorized access for user: ", error.serverResponse);
                                                return reject(error.serverResponse);
                                            case 'storage/canceled':
                                                console.log("upload canceled");
                                                return reject("upload canceled");
                                            case 'storage/unknown':
                                                return reject(error.serverResponse);
                                        }
                                    }, function() {
                                        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                                            resolve( {
                                                default: downloadURL
                                            } );
                                        });
                                    });

                                } ) );
                        }
                    }

                    ClassicEditor
                        .create( document.querySelector( '#editor' ),{
                            mediaEmbed: {
                                previewsInData: true
                            }
                        } )
                        .then( editor => {
                            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                                return new MyUploadAdapter( loader );
                            };
                            that.editorInstance = editor;

                            if(that.editPostData){
                                that.newPostId = that.docId;
                                that.presetCreateDate = that.editPostData.createDate;
                                that.published = that.editPostData.published;
                                that.newPostTag = {
                                    tag: that.editPostData.tag.tag,
                                    color: that.editPostData.tag.color
                                };
                                that.newPostTitle = that.editPostData.title;
                                that.newPostDescription = that.editPostData.description;

                                editor.setData(that.editPostData.text);
                            }

                        } )
                        .catch( error => {
                            console.error( error );
                        } );
                } else {
                    that.newPost = false;
                    that.$emit('toggle-post', that.newPost);
                    that.newPostBtnTxt = 'Atcelt';
                }
            },

            triggerThumbnailFileSelect: function(){
                this.$refs.uploadThumbnailRef.click();
            },
            thumbnailFileListChange: function(){
                const that = this;
                const fileList = this.$refs.uploadThumbnailRef.files;

                that.thumbnailUploadFileString = fileList[0].name;
                that.thumbnailFileList = fileList;
            },
            uploadThumbnailImage: function(postId, thumbnailFile, callback){
                const storageRef = firebase.storage().ref();
                const that = this;
                let thumbnailUrl = '';

                if((postId && thumbnailFile) || that.editPostData){
                    if(thumbnailFile){
                        const imageRef = storageRef.child('posthumbnails/'+postId+'/'+thumbnailFile[0].name);
                        const uploadTask = imageRef.put(thumbnailFile[0]);

                        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, function(/*snapshot*/) {
//                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, function(error) {
                            that.submittingPost = false;

                            switch (error.code) {
                                case 'storage/unauthorized':
                                    console.log("unauthorized access for user: ", error.serverResponse);
                                    break;
                                case 'storage/canceled':
                                    console.log("upload canceled");
                                    break;
                                case 'storage/unknown':
                                    console.log("unknown error: ", error.serverResponse);
                                    break;
                            }
                        }, function() {
                            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                                thumbnailUrl = downloadURL
                                    .substring(0, downloadURL.lastIndexOf("."))
                                        + "_320x160"
                                        + downloadURL.substring(downloadURL.lastIndexOf("."));

                                callback(thumbnailUrl, false);
                            });
                        });
                    } else {
                        callback(that.editPostData.thumbnail, false);
                    }
                } else {
                    alert("Nepieciešams thumbnail");
                    that.submittingPost = false;
                }
            },
            submitPost: function(){
                const that = this;
                that.submittingPost = true;

                that.uploadThumbnailImage(this.newPostId, this.thumbnailFileList, function(thumbnailUrl){
                    firebaseCfg.db.collection("posts").doc(that.newPostId).set({
                        author: that.author,
                        editor: that.editor ? that.editor : '',
                        published: that.published,
                        thumbnail: thumbnailUrl,
                        title: that.newPostTitle,
                        createDate: that.presetCreateDate ? that.presetCreateDate : firebase.firestore.Timestamp.fromDate(new Date()),
                        tag: {
                            tag: that.newPostTag.tag,
                            color: that.newPostTag.color,
                        },
                        description: that.newPostDescription,
                        text: that.editorInstance.getData()
                    });

                    that.submittingPost = false;
                    that.newPost = false;

                    that.$emit('toggle-post', that.newPost);
                    that.$emit("post-submitted");
                });
            }
        },
        mounted() {
        }
    }
</script>

<style>
    .ck-editor .ck-editor__editable {
        min-height: 150px;
        max-height: 550px;
    }
</style>
<style scoped>
    .blog-page__editor-placeholder {
        max-width: 900px;
        margin: 0 auto;
        justify-content: center;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .blog-page__post-btn {
        margin: 25px 0;
        display: flex;
        justify-content: center;
    }
    .blog-page__post-btn button {
        margin-left: 5px;
    }
</style>